import React, { useContext } from "react";
import { IntlContext } from "context";
import { SubCategory } from "types/subCategory";
import { BookingContext } from "app/OurService/Booking/Context";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";

const HouseKeepingFields: React.FC = () => {
    const intl = useContext(IntlContext);
    const booking = useContext(BookingContext);
    const subcategory = booking.getBooking()?.subcategory;
    const bringProducts = booking.getService()?.data.bring_products;

    return (
        <div className="grid--2 grid--small-1 grid--has-gutter-5x margin-top--4">
            {(subcategory === SubCategory.CLEANING) && (
                <div className="service_detail">
                    <Icon icon={{ prefix: "fas", iconName: "spray-can" }} />
                    <span className="margin-left--1">
                        {bringProducts
                            ? intl.formatMessage("our_services.label.bring_yes")
                            : intl.formatMessage("our_services.label.bring_no")}
                    </span>
                </div>
            )}
        </div>
    );
};

export default HouseKeepingFields;
